module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_8.eaad80b7.png";